'use strict';

/**
 * @ngdoc directive
 * @name prepApp.directive:courseTask
 * @description
 * # courseTask
 */
angular.module('prepApp')
    .directive('courseTask', function ($http, $log, APIs, ConfigService, Utils) {
        return {
            restrict: 'E',
            scope: {
                selectedCourse: '='
            },
            templateUrl: 'views/directives/coursetask.html',
            controller: function ($scope) {
                $scope.$watch('selectedCourse', function () {
                    $scope.updateTasks();
                });

                $scope.taskList = [];
                $scope.hideTaskTable = true;
                $scope.taskCountDone = 0;
                $scope.showFinishTask = false;
                $scope.showRemarkTask = false;
                $scope.selEditTask = undefined;
                $scope.noteTask = undefined;
                $scope.hideAddTask = true;
                $scope.showDelTask = false;

                $scope.toogleDivOrDialog = function (dialog) {
                    $scope[dialog] = !$scope[dialog];
                };

                $scope.clickTaskButton = function (task, elementName) {
                    $scope.selectedTask = task;
                    $scope.toogleDivOrDialog(elementName);
                };

                $scope.showRemarkTaskDialog = function (task) {
                    $scope.selectedTask = task;
                    if (angular.isUndefined($scope.selectedTask.remark) || $scope.selectedTask.remark === null ||
                     $scope.selectedTask.remark.length === 0) {
                        $scope.showRemarkTaskEditDialog(task);
                    } else {
                        $scope.toogleDivOrDialog('showRemarkTask');
                    }
                };

                $scope.showRemarkTaskEditDialog = function (task) {
                    $scope.selectedTask = task;
                    $scope.selEditTask = angular.copy($scope.selectedTask);
                    $scope.toogleDivOrDialog('showEditRemarkTask');
                };

                $scope.addTask = function (pAddTask) {
                    var createTaskURL = ConfigService.CONFIG.apiURL + 'createCourseTask/' + $scope.selectedCourse.id + '/';

                    $http.post(createTaskURL, { task: pAddTask.task, do_date: pAddTask.datepicker, remark: pAddTask.remark })
                        .then(function (data) {
                            $scope.taskList.push(data.data);
                            $scope.updateTasksList();
                        });

                    $scope.toogleDivOrDialog('hideAddTask');
                };

                $scope.finishTask = function () {
                    $scope.pFinishTask = angular.copy($scope.selectedTask);
                    $scope.pFinishTask.done_date = new Date().toJSON().slice(0, 16);
                    APIs.CourseTaskService.update($scope.pFinishTask, function (data) {
                        $scope.taskList.splice($scope.taskList.indexOf($scope.selectedTask), 1);
                        $scope.taskList.push(data);
                        $scope.updateTasksList();
                    });
                    $scope.toogleDivOrDialog('showFinishTask');
                };

                $scope.delTask = function () {
                    APIs.CourseTaskService.delete({ id: $scope.selectedTask.id }, function () {
                        $scope.taskList.splice($scope.taskList.indexOf($scope.selectedTask), 1);
                        $scope.updateTasksList();
                        $scope.toogleDivOrDialog('showDelTask');
                    });
                };

                $scope.updateTasks = function () {
                    if (angular.isDefined($scope.selectedCourse)) {
                        APIs.CourseTaskService.query({ course: $scope.selectedCourse.id }).$promise.then(function (data) {
                            $scope.updateTasksList(data);
                        });
                    }
                };

                $scope.updateTasksList = function (data) {
                    if (angular.isDefined(data) && data !== null) {
                        $scope.taskList = [];

                        angular.forEach(data, function (task) {
                            $scope.taskList.push(task);
                        });
                    }
                    $scope.taskCountDone = 0;
                    angular.forEach($scope.taskList, function (task) {
                        if (task.done_date !== null) {
                            $scope.taskCountDone++;
                        }
                        if (task.pinned) {
                            $scope.noteTask = task;
                        }
                    });
                    var actPage = $scope.tableParams.parameters().page;
                    if ($scope.taskList.length > 0) {
                        $scope.hideTaskTable = false;
                    } else {
                        $scope.hideTaskTable = true;
                    }
                    $scope.tableParams.settings({
                        dataset: $scope.taskList
                    });
                    $scope.tableParams.page(actPage);
                };

                $scope.createTasks = function () {
                    var creatTasksURL = ConfigService.CONFIG.apiURL + 'courseTasks/' + $scope.selectedCourse.id + '/';

                    $http.post(creatTasksURL, {})
                        .then(function (data) {
                            $scope.updateTasksList(data.data);
                        });
                };

                $scope.updateTaskRemark = function () {
                    APIs.CourseTaskService.update($scope.selEditTask, function (data) {
                        $scope.taskList.splice($scope.taskList.indexOf($scope.selectedTask), 1);
                        $scope.taskList.push(data);
                        $scope.updateTasksList();
                    });
                    $scope.selEditTask = undefined;
                    $scope.toogleDivOrDialog('showEditRemarkTask');
                };

                $scope.printTaskList = function () {
                    var pdfURL = ConfigService.CONFIG.backendURL + 'prep/pdf/tasks/' + $scope.selectedCourse.id + '/';
                    Utils.savePDFFile(pdfURL, $scope.selectedCourse.short_name + '_Tasks.pdf');
                };

                $scope.deleteTasks = function () {
                    var deleteTasksURL = ConfigService.CONFIG.apiURL + 'courseTasks/' + $scope.selectedCourse.id + '/';

                    $http.delete(deleteTasksURL, {}).then(function () {
                        $scope.updateTasks();
                        $scope.toogleDivOrDialog('showCourseCommmands');
                    });
                };

                $scope.cancelCourse = function () {
                    var cancelCourseURL = ConfigService.CONFIG.apiURL + 'cancelCourse/' + $scope.selectedCourse.id + '/';

                    $http.post(cancelCourseURL, {}).then(function () {
                        $scope.updateTasks();
                        $scope.toogleDivOrDialog('showCourseCommmands');
                    });
                };

                $scope.cols = [
                    { valueExpr: 'task.task', title: 'Aufgabe', filter: { task: 'text' }, show: true },
                    { valueExpr: 'task.do_date | date:\'dd.MM.yyyy (EEE)\'', title: 'zu erledigen', sortable: 'do_date', show: true },
                    { valueExpr: 'task.done_date | date:\'dd.MM.yyyy HH:mm\'', title: 'erledigt', show: true },
                    { field: 'action', title: '', dataType: 'command', class: 'actionWidth120' }
                ];

                $scope.tableParams = new ConfigService.NgTableParams({ page: 1, count: 10, sorting: { do_date: 'asc' } }, {
                    defaultSelectValue: 'Show all',
                    dataset: $scope.taskList
                });
            }
        };
    });
